import React, { useCallback, useState } from "react"

import { SectionDescription } from "./atoms"
import { Contacts, DeviceSyncedRow, LinkedInProposals } from "./molecules"
import { Wrapper } from "./syncContactsStyles"

export const SyncContacts = () => {
  // T-W2-F2 (2026-07-04): bumped after every LinkedIn upload so the proposals queue
  // (a sibling component) refetches without the two needing a shared store slice.
  const [linkedInRefreshKey, setLinkedInRefreshKey] = useState(0)

  const handleLinkedInUploaded = useCallback(() => {
    setLinkedInRefreshKey(key => key + 1)
  }, [])

  return (
    <div>
      <Wrapper>
        <SectionDescription />

        <Contacts onLinkedInUploaded={handleLinkedInUploaded} />
        <DeviceSyncedRow />
        <LinkedInProposals refreshKey={linkedInRefreshKey} />
      </Wrapper>
    </div>
  )
}
